<template>
  <CCard>
    <!-- 온도센서별 측정값. 사용중인 센서는 배경으로 구분한다 -->
    <table class="table table-sm small text-nowrap">
      <tr class="text-center">
        <td v-for="n in sensorCount" :key="`h${n}`">온도{{ n }}</td>
      </tr>
      <tr class="text-center font-weight-bolder">
        <td v-for="n in sensorCount" :key="`v${n}`" :class="{'bg-success': isUsed(n)}">
          {{ trans(pk[`tm${n}`], 't', tmpUnit) }}
        </td>
      </tr>
    </table>

    <!-- 평균/최고/최저는 패킷이 섭씨·화씨로 함께 주므로 환산하지 않는다 -->
    <table class="table table-sm small text-nowrap">
      <tr class="text-center">
        <td>평균온도(C)</td><td>평균온도(F)</td><td>최고온도</td><td>최저온도</td>
      </tr>
      <tr class="text-center font-weight-bold">
        <td>{{ pk.avgTm }}</td>
        <td>{{ pk.avgTmF }}</td>
        <td>{{ pk.maxTm }}</td>
        <td>{{ pk.minTm }}</td>
      </tr>
    </table>
  </CCard>
</template>

<script>
/**
 * 온도센서 상세 표
 *
 * Tank2D / Tank3D / Tank3DV2 / TankLorry 에 같은 표가 복사돼 있던 것을 하나로 모은 것이다.
 * 센서 개수(급유차만 1개)와 사용센서 강조 유무만 다르고 나머지는 같았다.
 *
 * 센서값은 표시단위로 환산한다. 종전에는 Tank3DV2 만 환산하고
 * Tank2D/Tank3D 는 원본(섭씨)을 그대로 찍어, 화씨로 바꿔도 이 표만 섭씨로 남았다.
 *
 * 표시 여부는 호출측이 v-show 로 정한다.
 */
import {trans} from '@/common/utils';

export default {
  name: 'TankTempTable',
  props: {
    // 현재 패킷
    pk: {type: Object, required: true},
    // 표시 온도단위
    tmpUnit: {type: String, default: 'C'},
    // 온도센서 개수
    sensorCount: {type: Number, default: 6},
    // 사용중인 센서 {tm1:true,...}. 없으면 강조하지 않는다
    tmUseMap: {type: Object, default: null},
  },
  methods: {
    trans,

    isUsed(n){
      return this.tmUseMap ? !!this.tmUseMap[`tm${n}`] : false;
    },
  },
}
</script>
